const data = {
  counterText: 'ಸೀಮಿತ ಸ್ಲಾಟ್‌ಗಳು ಲಭ್ಯವಿದೆ',
  loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ',
  next: 'ಮುಂದೆ',
  previous: 'ಹಿಂದಿನ',
  smCounterText: 'ಸೀಮಿತ ಸ್ಲಾಟ್‌ಗಳು ಉಳಿದಿವೆ',
};

export default data;
